import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b58db948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-container" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-inner" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "right-container" }
const _hoisted_6 = { class: "notice-description" }
const _hoisted_7 = { class: "notice-eg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoticeTypeBadge = _resolveComponent("NoticeTypeBadge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['radio', { selected: _ctx.selected }])
      }, _hoisted_4, 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_NoticeTypeBadge, {
        "notice-type": _ctx.noticeType.name
      }, null, 8, ["notice-type"]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.noticeType.description), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.noticeType.eg), 1)
    ])
  ]))
}